module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = void 0;
    var _Lozenge = __webpack_require__(2), _Lozenge2 = _interopRequireDefault(_Lozenge);
    exports.default = _Lozenge2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.APPEARANCE_ENUM = void 0;
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(6), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _Container = __webpack_require__(8), _Container2 = _interopRequireDefault(_Container), _Content = __webpack_require__(12), _Content2 = _interopRequireDefault(_Content), APPEARANCE_ENUM = exports.APPEARANCE_ENUM = {
        values: [ "default", "success", "removed", "inprogress", "new", "moved" ],
        defaultValue: "default"
    }, Lozenge = function(_PureComponent) {
        function Lozenge() {
            return (0, _classCallCheck3.default)(this, Lozenge), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        // returns the assigned appearance if valid, falling back to the default otherwise
        return (0, _inherits3.default)(Lozenge, _PureComponent), Lozenge.prototype.validAppearance = function() {
            var appearance = this.props.appearance, values = APPEARANCE_ENUM.values, defaultValue = APPEARANCE_ENUM.defaultValue;
            return values.indexOf(appearance) !== -1 ? appearance : defaultValue;
        }, Lozenge.prototype.render = function() {
            var _props = this.props, isBold = _props.isBold, children = _props.children;
            return _react2.default.createElement(_Container2.default, {
                appearance: this.validAppearance(),
                isBold: isBold
            }, _react2.default.createElement(_Content2.default, null, children));
        }, Lozenge;
    }(_react.PureComponent);
    Lozenge.propTypes = {
        /** Determines whether to apply the bold style or not. */
        isBold: _propTypes2.default.bool,
        /** The appearance type. */
        appearance: _propTypes2.default.oneOf(APPEARANCE_ENUM.values),
        /** Elements to be rendered inside the lozenge. This should ideally be just
	  a word or two. */
        children: _propTypes2.default.node
    }, Lozenge.defaultProps = {
        isBold: !1,
        appearance: APPEARANCE_ENUM.defaultValue
    }, exports.default = Lozenge;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 8 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(9), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  background-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: inline-flex;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  max-width: 200px;\n  padding: 2px ", " 3px ", ";\n  text-transform: uppercase;\n  vertical-align: baseline;\n  white-space: nowrap;\n" ], [ "\n  background-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: inline-flex;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  max-width: 200px;\n  padding: 2px ", " 3px ", ";\n  text-transform: uppercase;\n  vertical-align: baseline;\n  white-space: nowrap;\n" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(11), HORIZONTAL_SPACING = _utilSharedStyles.akGridSizeUnitless / 2 + "px", backgroundColor = {
        default: _utilSharedStyles.akColorN20,
        inprogress: _utilSharedStyles.akColorB50,
        moved: _utilSharedStyles.akColorY50,
        new: _utilSharedStyles.akColorP50,
        removed: _utilSharedStyles.akColorR50,
        success: _utilSharedStyles.akColorG50
    }, textColor = {
        default: _utilSharedStyles.akColorN500,
        inprogress: _utilSharedStyles.akColorB500,
        moved: _utilSharedStyles.akColorN600,
        new: _utilSharedStyles.akColorP500,
        removed: _utilSharedStyles.akColorR500,
        success: _utilSharedStyles.akColorG500
    }, boldBackgroundColor = {
        default: _utilSharedStyles.akColorN40,
        inprogress: _utilSharedStyles.akColorB500,
        moved: _utilSharedStyles.akColorY500,
        new: _utilSharedStyles.akColorP500,
        removed: _utilSharedStyles.akColorR500,
        success: _utilSharedStyles.akColorG500
    }, boldTextColor = {
        default: _utilSharedStyles.akColorN700,
        inprogress: _utilSharedStyles.akColorN0,
        moved: _utilSharedStyles.akColorN600,
        new: _utilSharedStyles.akColorN0,
        removed: _utilSharedStyles.akColorN0,
        success: _utilSharedStyles.akColorN0
    }, getBackgroundColor = function(_ref) {
        var appearance = _ref.appearance, isBold = _ref.isBold;
        return isBold ? boldBackgroundColor[appearance] : backgroundColor[appearance];
    }, getTextColor = function(_ref2) {
        var appearance = _ref2.appearance, isBold = _ref2.isBold;
        return isBold ? boldTextColor[appearance] : textColor[appearance];
    };
    exports.default = _styledComponents2.default.span(_templateObject, getBackgroundColor, _utilSharedStyles.akBorderRadius, getTextColor, HORIZONTAL_SPACING, HORIZONTAL_SPACING);
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 12 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(9), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n" ], [ "\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents);
    exports.default = _styledComponents2.default.span(_templateObject);
} ]);


//////////////////
// WEBPACK FOOTER
// ../lozenge/dist/bundle-cjs.js
// module id = 249
// module chunks = 0